import { makeAutoObservable, runInAction } from 'mobx'

import type { NotificationList, ResNotificationDetail, SellList, UnreadCount } from '../constants'
import type { components, operations } from '../constants/schema'

import { HttpReq } from '../utils'

import RootStore from './root'
import { PagingSubStore, SingleSubStore } from './subStore'

export type NotificationPermissionType = 'authorized' | 'provisional' | 'denied' | 'notDetermined' | 'unknown' | ''

export class NotificationStore {
  rootStore: RootStore
  unreadNotification: UnreadCount | null = null
  permission: NotificationPermissionType = ''

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  /* 공지사항 */
  noticePagingStore = new PagingSubStore<components['schemas']['NoticeDto']>('/notice') // 목록 조회
  noticeDetailStore = new SingleSubStore<components['schemas']['NoticeDto']>( // 상세 조회
    (param?: Record<string, any>) => `/notice/${param?.notificationId}`,
  )

  /* 알림 */
  notificationPagingStore = new PagingSubStore<components['schemas']['UserNotificationDto']>('/user/notification')
  unreadNotificationPagingStore = new PagingSubStore<components['schemas']['UserNotificationDto']>(
    '/user/notification/unread',
  )
  unreadNotificationCountStore = new SingleSubStore<components['schemas']['ResNumberResult']>(
    '/user/notification/unread/count',
  )

  /* 목록 조회 */
  notificationDetailStore = new SingleSubStore<ResNotificationDetail>( // 상세 조회
    (param?: Record<string, any>) => `/user/notification/${param?.notificationId}`,
  )

  /* 매각 */
  sellPagingStore = new PagingSubStore<SellList>('/user/notification/sell') // 목록 조회
  sellDetailStore = new SingleSubStore<ResNotificationDetail>( // 상세 조회
    (param?: Record<string, any>) => `/user/notification/${param?.notificationId}`,
  )

  /* 공시 */
  disclosureStore = new PagingSubStore<components['schemas']['DisclosureDto']>('/disclosure') // 목록 조회
  disclosureCategoryStore = new PagingSubStore<components['schemas']['DisclosureCategoryDto']>('/disclosure/category') // 공시 카테고리 조회
  disclosureDetailStore = new SingleSubStore<components['schemas']['DisclosureDto']>( // 상세 조회
    (param: operations['DisclosureController_findOne']['parameters']['path']) => `/disclosure/${param?.id}`,
  )

  /* 읽지 않은 알림 있을 시 뱃지 표시를 위한 api */
  isReadNotification = async () => {
    const unreadCount = await HttpReq<UnreadCount>({
      method: 'GET',
      url: `/user/notification/unreadCount`,
    })
    if (unreadCount == null) {
      return null
    }
    runInAction(() => {
      this.unreadNotification = unreadCount
    })
    return unreadCount
  }

  /* 알림 읽음 처리를 위한 api */
  readNotification = async (sequenceId: number) => {
    await HttpReq<NotificationList>({
      method: 'PUT',
      url: `/user/notification/${sequenceId}/read`,
    })
  }

  /* 알림 전체 읽음 */
  readAllNotification = async (): Promise<boolean> => {
    try {
      await HttpReq({
        method: 'PUT',
        url: '/user/notification/readAll',
      })
      return true
    } catch (error) {
      console.log('error: ', { error })
      return false
    }
  }

  setPermission(permission: NotificationPermissionType) {
    this.permission = permission
  }

  resetPermission() {
    this.permission = ''
  }
}
